import React from 'react';

function WhatsAppIcon(props) {
  return (
    <svg viewBox="0 0 32 32" fill="currentColor" {...props}>
      <path d="M16.004 3C9.377 3 4 8.373 4 15c0 2.373.7 4.583 1.902 6.435L4 29l7.73-1.868A11.94 11.94 0 0 0 16.004 27C22.63 27 28 21.627 28 15S22.63 3 16.004 3zm0 21.75a9.7 9.7 0 0 1-4.95-1.354l-.355-.21-4.59 1.11 1.226-4.472-.232-.367A9.7 9.7 0 0 1 5.75 15c0-5.658 4.596-10.25 10.254-10.25 5.657 0 10.246 4.592 10.246 10.25s-4.589 10.25-10.246 10.25zm5.63-7.68c-.308-.154-1.823-.9-2.106-1.003-.283-.103-.489-.154-.694.155-.206.308-.797 1.003-.978 1.208-.18.206-.36.232-.668.078-.308-.155-1.3-.479-2.475-1.527-.915-.816-1.532-1.824-1.712-2.132-.18-.309-.019-.476.135-.63.139-.138.309-.36.463-.54.155-.18.206-.309.309-.514.103-.206.051-.386-.026-.541-.077-.155-.694-1.673-.951-2.29-.25-.6-.505-.52-.694-.53-.18-.008-.386-.01-.592-.01-.206 0-.541.077-.824.386-.283.309-1.08 1.056-1.08 2.574 0 1.518 1.106 2.984 1.26 3.19.154.206 2.176 3.322 5.27 4.658.736.318 1.31.508 1.758.65.738.235 1.41.202 1.941.123.592-.089 1.823-.745 2.08-1.464.257-.72.257-1.336.18-1.464-.077-.129-.283-.206-.591-.36z"/>
    </svg>
  );
}

export default function WhatsAppWidget() {
  const phone = '919032809977';
  const message = encodeURIComponent('Hi! I am interested in your training programs. Can you share more details?');

  return (
    <a
      href={`https://wa.me/${phone}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-widget"
      className="fixed bottom-6 right-6 z-50 flex items-center hover:scale-105 transition-transform duration-200"
      aria-label="WhatsApp us"
    >
      <span className="relative z-10 w-14 h-14 rounded-full bg-white shadow-lg flex items-center justify-center flex-shrink-0">
        <span
          className="w-12 h-12 rounded-full flex items-center justify-center"
          style={{ background: 'linear-gradient(180deg, #5FD669 0%, #26B43E 100%)' }}
        >
          <WhatsAppIcon className="w-8 h-8 text-white" />
        </span>
      </span>
      <span className="hidden sm:inline-block bg-[#E5E5E5] text-[#6F6F6F] font-body font-medium text-base tracking-wide rounded-full -ml-8 pl-11 pr-6 py-2.5 shadow-md">
        WhatsApp us
      </span>
    </a>
  );
}
